<template>
  <div>
    <b-row class="below">
      <b-col sm="2" lg="2">{{ qdesc }}</b-col>
      <b-col v-html="title"></b-col>
    </b-row>

    <template v-if="q_type == '1'">
      <b-row class="below" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">정답{{ a.id }}</b-col>
        <b-col v-html="a.t2"></b-col>
        <b-col sm="3" lg="3">{{ a.t1 }}</b-col>
      </b-row>
    </template>
    <template v-if="q_type == '2'">
      <b-row class="below" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">선택지{{ a.id }}</b-col>
        <b-col sm="3" lg="3">{{ a.t1 }}</b-col>
        <b-col sm="3" lg="3">{{ a.t3 }}</b-col>
        <b-col v-html="a.t2"></b-col>
      </b-row>
    </template>

    <template v-if="q_type == '3'">
      <b-row class="below" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">선택지{{ a.id }}</b-col>
        <b-col sm="3" lg="3" v-html="a.t1"></b-col>
        <b-col sm="3" lg="3">{{ a.t3 }}</b-col>
        <b-col v-html="a.t2"></b-col>
      </b-row>
    </template>
    <template v-if="q_type == '4'">
      <b-row class="below" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">정답</b-col>
        <b-col sm="3" lg="3" v-html="a.t1"></b-col>
      </b-row>
    </template>
    <template v-if="q_type == '5'">
      <b-row class="below tied" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">문항{{ a.id }}</b-col>
        <b-col sm="3" lg="3" v-html="a.t1"></b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    q_type() {
      return this.$store.state.questionform.q_type;
    },
    qdesc() {
      if (this.q_type != "5") {
        return "문제";
      } else {
        return "선택보기용 지문";
      }
    },

    title() {
      return this.$store.state.questionform.title;
    },
    answers() {
      let qform = this.$store.state.questionform;
      console.log(qform);
      let answers = [];
      if (this.q_type == "1") {
        for (let i = 1; i <= 10; i++) {
          if (qform[`ans${i}_text`] != "") {
            let a = {};
            a.id = i;
            a.t1 = qform[`ans${i}`];
            a.t2 = qform[`ans${i}_text`];
            answers.push(a);
          }
        }
      } else if (this.q_type == "2") {
        console.log(qform);

        for (let i = 0; i < this.$store.state.qtype2_picks.length; i++) {
          let a = {};
          a.id = i + 1;
          a.t1 = this.$store.state.qtype2_picks[i].text;
          a.t3 = this.$store.state.qtype2_picks[i].sub ? "[정답]" : "";
          answers.push(a);
        }
      } else if (this.q_type == "3") {
        console.log(this.$store.state.qtype3_picks);

        for (let i = 0; i < this.$store.state.qtype3_picks.length; i++) {
          let a = {};
          a.id = i + 1;
          a.t1 = this.$store.state.qtype3_picks[i].text;
          a.t2 = this.$store.state.qtype3_picks[i].answer;

          a.t3 = this.$store.state.qtype3_picks[i].sub ? "[정답]" : "";
          answers.push(a);
        }
      } else if (this.q_type == "4") {
        let a = {};
        a.id = 1;
        a.t1 = qform.ans1;
        answers.push(a);
      } else if (this.q_type == "5") {
        for (let i = 0; i < this.$store.state.qtype5_picks.length; i++) {
          let a = {};
          a.id = i + 1;
          a.t1 = this.$store.state.qtype5_picks[i].text;
          // a.t2 = this.$store.state.qtype5_picks[i].answer;
          answers.push(a);
        }
      }

      return answers;
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.below {
  padding-bottom: 6px;
  padding-top: 6px;
  border-bottom: 1px solid $gray100;
  img {
    max-width: 450px;
  }
}
.tied {
  background: white;
}
</style>